// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a6cdccc1","239":"74ec95b4","455":"10d80f0d"}[chunkId] + ".chunk.js";
};